import {
  ChevronLeft,
  ChevronRightRounded,
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowRightRounded,
} from "@mui/icons-material";
import { PaginationComponentProps } from "react-data-table-component";
import "./pagination.scss";
const ROWS_PER_PAGE = ["15", "30", "50"];
function getNumberOfPages(rowCount: number, rowsPerPage: number) {
  return Math.ceil(rowCount / rowsPerPage);
}

function getPages(page: number, pagesCount: number, paginationSize: number) {
  const result: number[] = [];
  if (!page) {
    return result;
  }

  if (pagesCount === 1) {
    result.push(1);
    return result;
  }

  if (pagesCount < page) {
    return result;
  }

  if (pagesCount < paginationSize + 1) {
    for (let i = 1; i < pagesCount + 1; i++) {
      result.push(i);
    }
    return result;
  }

  if (page === 1) {
    for (let i = 1; i < paginationSize + 1; i++) {
      if (i < pagesCount) {
        result.push(i);
      }
    }
    return result;
  }

  if (page === pagesCount) {
    for (let i = pagesCount - paginationSize + 1; i <= pagesCount; i++) {
      if (i <= pagesCount) {
        result.push(i);
      }
    }
    return result;
  }

  const shiftCount = Math.floor(paginationSize / 2);
  if (shiftCount < 1) {
    result.push(page);
    return result;
  }

  //
  if (page < shiftCount + 2) {
    for (let i = 1; i < paginationSize + 1; i++) {
      result.push(i);
    }
    return result;
  }

  if (pagesCount - page < shiftCount + 2) {
    for (let i = pagesCount - paginationSize; i < pagesCount + 1; i++) {
      result.push(i);
    }
    return result;
  }

  for (let i = page - shiftCount; i < page; i++) {
    if (i > 0) {
      result.push(i);
    }
  }
  result.push(page);
  for (let i = page + 1; i < page + shiftCount + 1; i++) {
    if (i <= pagesCount) {
      result.push(i);
    }
  }

  return result;
}

/* eslint-disable-next-line */
export interface PaginationProps extends PaginationComponentProps {}

export function Pagination({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
}: PaginationProps) {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1, pages);
  };
  const handleFirstPageClick = () => {
    onChangePage(1, pages);
  };
  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1, pages);
  };
  const handleLastPageClick = () => {
    onChangePage(pages, pages);
  };
  const handlePageNumber = (e: any) => {
    onChangePage(Number(e.target.value), pages);
  };
  const handleRowsPerPage = (eventKey: any, event: any) => {
    onChangeRowsPerPage(Number(eventKey), currentPage);
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const numberVisiblePages = 4;
  const pageItems = getPages(currentPage, pages, numberVisiblePages);
  const nextDisabled = currentPage === pages || pages === 0;
  const previosDisabled = currentPage === 1;

  const first = (currentPage - 1) * rowsPerPage + 1;
  const last =
    currentPage * rowsPerPage < rowCount ? currentPage * rowsPerPage : rowCount;
  return (
    <div className={`pagination-container pagination-container_default`}>
      <div className="pagination-results">
        Mostrando {first} a {last} de {rowCount} Resultados
      </div>

      <div className="pagination-buttons">
        <nav>
          <ul className="pagination" style={{ justifyContent: "right" }}>
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={handleFirstPageClick}
                disabled={previosDisabled}
                aria-disabled={previosDisabled}
                aria-label="previous page"
              >
                <KeyboardDoubleArrowLeftRounded className="icon-arrow" />
              </button>
            </li>
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={handleBackButtonClick}
                disabled={previosDisabled}
                aria-disabled={previosDisabled}
                aria-label="previous page"
              >
                <ChevronLeft sx={{ fontSize: 32, color: "#808285" }} />
              </button>
            </li>

            {pageItems[0] > 1 && (
              <li className="page-item">
                <button
                  className="page-link"
                  type="button"
                  aria-label="previous page"
                >
                  ...
                </button>
              </li>
            )}
            {pageItems.map((page) => {
              const className =
                page === currentPage ? "page-item active" : "page-item";

              return (
                <li key={page} className={className}>
                  <button
                    className="page-link"
                    onClick={handlePageNumber}
                    value={page}
                    type="button"
                  >
                    {page}
                  </button>
                </li>
              );
            })}

            {pageItems[pageItems.length - 1] < pages && (
              <li className="page-item">
                <button
                  type="button"
                  className="page-link"
                  aria-label="previous page"
                >
                  ...
                </button>
              </li>
            )}
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={handleNextButtonClick}
                disabled={nextDisabled}
                aria-disabled={nextDisabled}
                aria-label="next page"
              >
                <ChevronRightRounded className="icon-arrow" />
              </button>
            </li>
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={handleLastPageClick}
                disabled={nextDisabled}
                aria-disabled={nextDisabled}
                aria-label="next page"
              >
                <KeyboardDoubleArrowRightRounded className="icon-arrow" />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Pagination;
